import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enUS from 'vant/lib/locale/lang/en-US'
import zhCN from 'vant/lib/locale/lang/zh-CN'
import enLocale from './en'
import zhLocale from './zh'
import store from '@/store'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...enUS
  },
  zh: {
    ...zhLocale,
    ...zhCN
  }
}

const i18n = new VueI18n({
  locale: store.getters.language || 'zh', // set locale
  messages // set locale messages
})

export default i18n
